module.exports = __webpack_public_path__ + "img/trinpod_secure.0b3407bd.png";